<template>
  <section class="contactsectie">
    <div class="extrapartnerdiv">
      <img src="./../assets/img/logo_vives_int.svg" class="logovives" />
      <p>
        <br />En collaboration avec
        <router-link to="/partners">les partenaires suivants.</router-link>
      </p>
    </div>
    <div class="rightcontactblok">
      <nav class="social">
        <!--ul>
          <li><a href="">Instagram</a></li>
          <li><a href="">Facebook</a></li>
          <li><a href="">Twitter</a></li>
        </ul-->
      </nav>
      <address class="contact">
        <p class="name">Vives</p>
        <p class="other">Praktijk Gericht Wetenschappelijk Onderzoek</p>
        <p class="other">Doorniksesteenweg 145</p>
        <p class="other">8500 Kortrijk</p>
        <p class="other">Belgium</p>
      </address>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
.extrapartnerdiv {
  font-size: 1.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logovives {
  width: 238px;
  height: 77px;
}

.social ul,
.contact,
.contactsectie {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contactsectie {
  margin-top: 4rem;
}
.social {
  margin-top: 4rem;
}
.contact {
  margin-top: 4rem;
  margin-bottom: 1.1rem;
}
.contact .name {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
}
.contact .other {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.85;
  letter-spacing: normal;
  color: var(--articlebodycolor);
  text-align: center;
}
.social a {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: var(--titleslidecolor);
}

/* tablet */
@media only screen and (min-width: 768px) {
  .extrapartnerdiv {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .footer {
    flex-direction: row;
    justify-content: space-between;
  }
  .rightcontactblok {
    display: flex;
    align-items: baseline;
  }
  .social {
    margin-right: 4rem;
  }
  .contact {
    align-items: flex-start;
  }
}
</style>
